import { apiSlice } from '../../app/api/apiSlice'
import { IBank } from '../../components/Dashboard/account-page/types'
import { urlConfig } from '../../config'

export interface ISession {
  _id: string
  user: string
  sessionId: string
  userAgent: string
  clientIp: string
  platform: string
  createdAt: string
  updatedAt: string
  isBanned: boolean
  expireAt: string
}

export const bankSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    getSessions: build.query<ISession[], void>({
      query: () => `${urlConfig.authBaseUrl}/auth/sessions`,
      providesTags: ['Session'],
    }),
    deleteAllSessions: build.mutation<any, void>({
      query: () => ({
        url: `${urlConfig.authBaseUrl}/auth/sessions`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Session'],
    }),
    deleteSession: build.mutation<any, string>({
      query: sessionId => ({
        url: `${urlConfig.authBaseUrl}/auth/sessions/${sessionId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Session'],
    }),
  }),
})

export const {
  useDeleteAllSessionsMutation,
  useGetSessionsQuery,
  useDeleteSessionMutation,
} = bankSlice
